import KakaoLogin from "react-kakao-login";
import axios from 'axios';

const SocialKakao=({handleLogin})=>{

    const kakaoClientId = 'faac188167b161c26238eadc69d163ca'
    const kakaoOnSuccess = async (data)=>{
        const access_token = data.response.access_token  // 엑세스 토큰 백엔드로 전달

        const response = await axios.post('/kakaoauth/tokens', { access_token });
        const { token, uuid, username } = response.data;
        handleLogin(token, uuid,username );
        // alert(response.data.message || 'Kakao Login Success!');
    }
    const kakaoOnFailure = (error) => {
        console.log(error);
    };
    return(
        <div className="social-button-container">
          <KakaoLogin
              token={kakaoClientId}
              onSuccess={kakaoOnSuccess}
              onFail={kakaoOnFailure}
            //   render={({ onClick }) => (
            //     <button className="social-button kakao" onClick={onClick}>
            //       <span className="emoji-button">😀</span>
            //       <span className="button-text">카카오로 로그인</span>
            //     </button>
            //   )}
          />
         </div>
    )
}

export default SocialKakao
